import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { DifferentiatorsSection } from '../components/DifferentiatorsSection';
import { FeaturedModelSection } from '../components/FeaturedModelSection';
import { RobetaDifferenceSection } from '../components/RobetaDifferenceSection';
import { DealerCTASection } from '../components/DealerCTASection';
import { DiscoverBrandSection } from '../components/DiscoverBrandSection';
import { NewsletterSection } from '../components/NewsletterSection';
import { useSEO } from '../hooks/useSEO';
export function HomePage() {
  useSEO({
    title: 'European Luxury Class B Camper Vans for North America',
    description: 'Robeta Canada — European-crafted luxury Class B camper vans built for North American adventure. Discover precision engineering, premium interiors, and innovative Air Furniture Technology.'
  });
  return <main data-id="element-541">
      <HeroSection data-id="element-542" />
      <DifferentiatorsSection data-id="element-543" />
      <FeaturedModelSection data-id="element-544" />
      <RobetaDifferenceSection data-id="element-545" />
      <DealerCTASection data-id="element-546" />
      <DiscoverBrandSection data-id="element-547" />
      <NewsletterSection data-id="element-548" />
    </main>;
}